import { client } from "../../api/clientAutotask"

export const fetchTicketAttachmentById = async (id) => {
    var uri = "autotaskapi/ticketattachments/" + id
    var responseAutotask = await client.get(uri)
    return responseAutotask.data
}